/* Card Slider */
'use strict';

(function ($, Drupal, once) {
  Drupal.behaviors.CareySlickSlider = {
    attach: function () {
      $(once('CareySlickSlider', '.slick-slider')).each(function () {
        $(this).slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst:true,
          appendArrows: $('.js-appended-arrows'),
          prevArrow: '<button type="button" class="slick-prev">&#10094;</button>',
          nextArrow: '<button type="button" class="slick-next">&#10095;</button>',
          responsive: [
            {
              breakpoint: 992,
              settings: 'unslick'
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      });
    }
  };
})(jQuery, Drupal, once);
